import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';
import { FireblockService } from '../fireblockvault/fireblockvault.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { NotificationsService } from 'angular2-notifications';

const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-exchangedeposit',
    templateUrl: './exchangedeposit.component.html',
    styleUrls: ['./exchangedeposit.component.css']
})
export class ExchangeDepositComponent implements OnInit {
    displayedColumns = [
        'currency',
        'assetid',
        'amount',
        'vault_id',
        'exchange',
        'address',
        'tx_id',
        'tx_hash',
        'note',
        'fee',
        'fee_currency',
        'is_gross',
        'status',
        'fireblock_status',
        'fireblock_sub_status',
        'createdAt',
        'action'
    ];
    fromDate;
    toDate;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    public exchangeDepositDataSource: any = new MatTableDataSource();
    pageSize = 10;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private userService: UserService,
        private fireblock: FireblockService,
        public dialog: MatDialog,
        private notifSer: NotificationsService
    ) { }

    ngOnInit() {
        this.csrf();
        this.applyRefreshData();
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.exchangeDepositDataSource.filter = filterValue;
    }
    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.fireblock.getExchangeDeposit(this.filter).subscribe((success) => {
                let exchangeDepositRes = success.map(exchangeDeposit => {
                    exchangeDeposit.createdAt = moment(exchangeDeposit.createdAt).format('MM/DD/YY h:mm:ss A');
                    return exchangeDeposit;
                })
                this.exchangeDepositDataSource = new MatTableDataSource(exchangeDepositRes);
                this.exchangeDepositDataSource.paginator = this.paginator
                this.exchangeDepositDataSource.sort = this.sort;
            })
        })
    }
    approveCancelExchangeDeposit(element: any, status: string) {
        try {
            this.userService.csrf().subscribe(data => {
                const obj = {
                    _id: element._id,
                    orderReference: element.tx_id,
                    Action: status
                }
                obj['_csrf'] = data._csrf;
                this.dialog.open(ConfirmationDialogComponent, {
                    data: {
                        message: `Are you sure want to approve?`,
                        buttonText: {
                            ok: 'Yes',
                            cancel: 'No'
                        }
                    }
                }).afterClosed().subscribe((confirmed: boolean) => {
                    if (confirmed) {
                        const { notif } = defaults;
                        this.fireblock.approveCancelExchangeDeposit(obj).subscribe(delRes => {
                            if (delRes) {
                                this.notifSer.success('Success', delRes.message, notif)
                                this.applyRefreshData();
                            }
                            else this.notifSer.error('Error', delRes.message, notif)
                        })
                    }
                });
            })

        } catch (error) {
            console.log(error);
        }
    }
    async exportArray() {
        if (this.exchangeDepositDataSource.filteredData) {
            const exchangeDeposit = await this.exchangeDepositDataSource.filteredData.map(x => ({
                Currency: x.currency,
                AssetId: x.assetid,
                Amount: x.amount,
                VaultId: x.vault_id,
                Exchange: x.exchange,
                Address: x.address,
                TransactionId: x.tx_id,
                TransactionHash: x.tx_hash,
                Note: x.note,
                Status: x.status,
                Fee: x.fee,
                FeeCurrency: x.fee_currency,
                IsGross: x.is_gross,
                FireblockStatus: x.fireblock_status,
                fireblockSubStatus: x.fireblock_sub_status,
                createdAt: x.createdAt,
            }));
            TableUtil.exportArrayToExcel(exchangeDeposit, "exchange-deposit");
        }

    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
}


// WEBPACK FOOTER //
// ./src/app/exchangedeposit/exchangedeposit.component.ts